<template>
  <div class="taskbox">
    <div class="circle">
      <div class="circle-wave">
        <div class="circle-wave-bg"></div>
        <div class="circle-wave-inner">
          <div class="circle-wave-desc">
            {{ stateInfo }}
          </div>
        </div>
      </div>
    </div>
    <div class="verticalline"></div>
    <div class="task">
      <div class="taskname">{{ task }}</div>
      <div id="barparent" class="barparent" :class="{ barparentMin: screenSize < 1200 }">
        <div id="barBox" class="barBox" :class="{ barBoxMin: screenSize < 1200 }">
          <div id="bar" class="bar" ref="bar"></div>
        </div>
        <p style="margin-left: 2%" id="percent">{{ schedule }}%</p>
        <p id="state" style="width: 100%">{{ $t("index.device") + stateInfo }}</p>
      </div>
      <div class="taskxyzMin" :class="{ taskxyz: screenSize > 1200 }">
        <div class="xyzitems" :class="{ xyzitemsMin: screenSize < 1200 }">
          <div class="xyztitle">{{ $t("index.x") }}</div>
          <div class="xyznumber" :title="x">{{ x }}</div>
        </div>
        <div class="xyzitems" :class="{ xyzitemsMin: screenSize < 1200 }">
          <div class="xyztitle">{{ $t("index.y") }}</div>
          <div class="xyznumber" :title="y">{{ y }}</div>
        </div>
        <div class="xyzitems" :class="{ xyzitemsMin: screenSize < 1200 }">
          <div class="xyztitle">{{ $t("index.z") }}</div>
          <div class="xyznumber" :title="z">{{ z }}</div>
        </div>
        <div class="xyzitems" :class="{ xyzitemsMin: screenSize < 1200 }">
          <div class="xyztitle">{{ $t("index.w") }}</div>
          <div class="xyznumber" :title="w">{{ w }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
const props = defineProps({
  devicein: { type: Object, required: true },
  stateInfo: { type: String, required: true },
  stateColor: { type: String, required: true },
});

const stateInfo = ref(props.stateInfo);
const stateColor = ref(props.stateColor);

let state = ref(props.devicein.state);
let stateCode = ref(props.devicein.stateCode);
let task = ref(props.devicein.task);
let schedule = ref(props.devicein.schedule);
let x = ref(props.devicein.x);
let y = ref(props.devicein.y);
let z = ref(props.devicein.z);
let w = ref(props.devicein.w);

/* let stateColor =
  state.value == "0"
    ? "#e0bb00" //黄色
    : state.value == "1"
    ? "#009431" //绿色
    : state.value == "2"
    ? "#e0bb00" //黄色
    : state.value == "3"
    ? "#e00000" //红色
    : "#0064c8"; //蓝色 */
/* let barstate =
  stateCode.value == "0" || stateCode.value == "1"
    ? "设备空闲"
    : stateCode.value == "2"
    ? "加工开始中"
    : stateCode.value == "3"
    ? "设备运行"
    : stateCode.value == "4"
    ? "设备暂停中"
    : stateCode.value == "5"
    ? "设备暂停"
    : stateCode.value == "6"
    ? "设备停止中"
    : stateCode.value == "7"
    ? "设备急停中"
    : stateCode.value == "8"
    ? "设备急停"
    : "设备离线"; */

let deviceItemsState =
  state.value == "0"
    ? t("index.idle")
    : state.value == "1"
    ? t("index.run")
    : state.value == "2"
    ? t("index.idle")
    : state.value == "3"
    ? t("index.stop")
    : t("index.offline");

let bar = ref(null);

onMounted(() => {
  loading(0);
  loading(schedule.value);
});

function loading(schedule) {
  bar.value.style.width = `${schedule}%`;
}
</script>

<style scoped>
.taskbox {
  display: flex;
  justify-content: space-between;
}
.verticalline {
  width: 1px;
  background-color: #e3e4e6;
  margin: 0px 30px;
}
.circle {
  align-items: center;
  display: inline-flex;
  margin: 0px 18px;
  justify-content: center;
  min-width: 200px;
  overflow: hidden;
  position: relative;
  padding: 15px;
  font-size: 12px;
}
.circle-wave {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 170px;
}
.circle-wave:before {
  border-radius: 56% 56% 52% 54%;
  animation: wave 12s infinite linear;
  background-color: v-bind("stateColor");
  opacity: 0.8;
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.circle-wave:after {
  border-radius: 44% 44% 42% 46%;
  animation: wave 10s infinite linear;
  background-color: v-bind("stateColor");
  opacity: 0.6;
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.circle-wave-bg {
  border-radius: 46% 46% 42% 44%;
  animation: wave 8s infinite linear;
  background-color: v-bind("stateColor");
  opacity: 0.4;
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.circle-wave-inner {
  color: v-bind("stateColor");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: 152px;
  height: 152px;
  background: #fff;
  border-radius: 70% 60% 60% 60%;
}
@keyframes wave {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.circle-wave-desc {
  font-size: 48px;
  line-height: 1;
  display: inline-flex;
  align-items: flex-end;
}
.task {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
}
.taskname {
  font-weight: bold;
}
p {
  margin: 0px;
}
.barparent {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.barparentMin {
  margin-bottom: 0px !important;
}
.barBox {
  width: 85%;
  height: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 15px 0px;
}
.barBoxMin {
  margin: 13px 0px !important;
}
.bar {
  height: 100%;
  width: 0px;
  background: v-bind("stateColor");
  border-radius: 5px;
  transition: all 1s;
}
.taskxyz {
  width: 100%;
  position: relative;
  display: flex;
  height: 80px;
  min-height: 80px;
  box-sizing: border-box;
}
.taskxyzMin {
  width: 100%;
  position: relative;
  box-sizing: border-box;
}
.xyzitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  flex: 1;
  height: auto;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 25%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
  margin-right: 10px;
}
.xyzitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.xyzitemsMin {
  width: 100%;
  margin-top: 10px;
}
.xyztitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.xyznumber {
  display: block;
  /* line-height: 50px;
  height: 50px; */
  font-size: 24px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
